import { useRef, useState } from "react";
import { Button, Table } from "flowbite-react";
import { useLists } from "../../contexts/ListsContext";
import ListRow from "./ListRow";
import CreateModal from "./CreateModal";

const Lists = () => {
  const targetRef = useRef(null);
  const columns = ['Name', 'Influencers', 'Date created', 'Actions'];
  const { lists, refreshLists } = useLists();
  const [openModal, setOpenModal] = useState(false);

  return (
    <>
      <div className="flex gap-2 justify-between items-center border-b border-gray-200 bg-white p-4 dark:border-gray-700 dark:bg-gray-800 sm:flex">
        <h1 className="text-xl font-semibold text-gray-900 dark:text-white sm:text-2xl">Lists</h1>
        <Button onClick={() => setOpenModal(true)}>
          Create list
        </Button>
      </div>
      {lists.length > 0 ? (
        <div ref={targetRef} className="overflow-x-auto">
          <Table>
            <Table.Head>
              {columns.map((column, key) => (
                <Table.HeadCell key={key}>{column}</Table.HeadCell>
              ))}
            </Table.Head>
            <Table.Body className="divide-y">
              {lists.map((list, key) => (
                <ListRow key={key} list={list} refreshLists={refreshLists} />
              ))}
            </Table.Body>
          </Table>
        </div>
      ) : (
        <p className="mt-4 text-center text-gray-500">No lists found</p>
      )}
      
      <CreateModal openModal={openModal} setOpenModal={setOpenModal} refreshLists={refreshLists} />
    </>
  );
}

export default Lists;